import React, { useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { SERVER_BASE_URL } from "../../core/config/constants";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

export default function RedirectBridge() {
  const { code, "*": splat } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const reservedRoutes = [
      "signin",
      "workspace",
      "admin",
      "reports",
      "campaigns",
      "templates",
      "contacts",
      "groups",
      "phone-numbers",
      "ledgers",
      "messages",
      "tickets",
      "docs",
      "api-docs",
      "tiny-urls",
      "links",
      "link-expired",
      "link-not-found",
    ];

    if (code && reservedRoutes.includes(code.toLowerCase())) {
      navigate(`/${code}${location.search}`, { replace: true });
      return;
    }

    if (code && /^[a-zA-Z0-9]{6}$/.test(code)) {
      const subpath = splat ? `/${splat}` : "";
      const search = location.search || "";
      const backendRedirectUrl = `${SERVER_BASE_URL}/${code}${subpath}${search}`;
      window.location.replace(backendRedirectUrl);
    } else {
      navigate(`/link-not-found?code=${encodeURIComponent(code || "")}&reason=invalid_code`, { replace: true });
    }
  }, [code, splat, location.search, navigate]);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-gray-900 flex flex-col items-center justify-center p-4">
      <div className="w-12 h-12 rounded-2xl bg-blue-50 dark:bg-blue-900/40 text-[#3a57e8] flex items-center justify-center mb-4 shadow-xs animate-pulse">
        <ArrowPathIcon className="w-6 h-6 animate-spin" />
      </div>
      <p className="text-sm font-semibold text-gray-700 dark:text-gray-200">
        Wait...
      </p>
      <p className="text-xs text-gray-400 mt-1">Please wait a moment.</p>
    </div>
  );
}
